<template>
  <div class="padding-max">
    <div class="bg-primary d-flex align-center py-4 px-5 border-radius-top-t">
      <h2 class="white--text">Integraciones</h2>
    </div>
    <div class="cont border-radius-bottom">
      <v-tabs v-model="tab">
        <v-tab>CSV</v-tab>
        <v-tab>New IPCOMtact</v-tab>
      </v-tabs>
      <CSVTagConfig v-if="tab == 0"></CSVTagConfig>
      <IPCOMtact v-if="tab == 1"></IPCOMtact>
    </div>
  </div>
</template>
<script>
import CSVTagConfig from "@/components/csv-tag-config/CSVTagConfig.vue";
import IPCOMtact from "@/components/ipcomtact";
export default {
  components: {
    CSVTagConfig,
    IPCOMtact,
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>
<style lang="scss">
#configuration {
  padding: 12px;
  margin: -12px;
  border-radius: 1rem;
  width: auto;
  height: calc(100vh - 64px);
  animation: fade 1s ease-in-out;
  .cont {
    width: 100%;
    background: #ffffff;
  }
  .v-sheet.v-stepper:not(.v-sheet--outlined) {
    box-shadow: none;
  }
}
</style>
